module.exports = __webpack_public_path__ + "static/media/facebook.f336be02.png";